'use client'

import RichText from '@/components/RichText'
import { bgClass } from '@/utilities/bgClass'
import type { ImpactReportListBlock as ImpactReportListProps } from '@/payload-types'
import { ReactElement, JSXElementConstructor, ReactNode, ReactPortal } from 'react'

export const ImpactReportListBlock = (props: ImpactReportListProps & { id?: string }) => {
  const { id, introContent, rows = [], background = 'none' } = props

  if (!rows.length) return null

  return (
    <section id={id ? `block-${id}` : undefined} className={`${bgClass(background)} py-12 md:py-16`}>
      <div className="container space-y-10">
        {introContent ? (
          <RichText data={introContent} enableGutter={false} className="[&_p]:max-w-3xl" />
        ) : null}

        <div className="overflow-hidden rounded-3xl border border-neutral-200 bg-white shadow-sm dark:border-neutral-700 dark:bg-neutral-900/60">
          <ul className="divide-y divide-neutral-200 dark:divide-neutral-700">
            {rows.map((row, index) => {
              const key = row?.id ?? `${row?.year ?? 'year'}-${index}`

              return (
                <li
                  key={key}
                  className="flex flex-col gap-6 px-6 py-6 sm:px-8 md:flex-row md:items-center md:justify-between"
                >
                  <div className="space-y-2">
                    {row?.year ? (
                      <p className="text-xs font-semibold uppercase tracking-[0.24em] text-emerald-600 dark:text-emerald-300">
                        {row.year}
                      </p>
                    ) : null}
                    {row?.title ? (
                      <p className="text-lg font-semibold text-neutral-900 dark:text-neutral-100 md:text-xl">
                        {row.title}
                      </p>
                    ) : null}
                  </div>

                  {row?.pdfUrl ? (
                    <a
                      href={row.pdfUrl}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center justify-center rounded-full border border-emerald-600 px-6 py-2 text-sm font-semibold uppercase tracking-wide text-emerald-700 transition hover:bg-emerald-600 hover:text-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600 dark:border-emerald-400 dark:text-emerald-300 dark:hover:bg-emerald-400 dark:hover:text-neutral-900"
                    >
                      {row.linkLabel || 'View report'}
                    </a>
                  ) : null}
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </section>
  )
}

export default ImpactReportListBlock